import React from 'react';
import { Stack } from 'react-bootstrap';
import MHRSync from './MHRSync';
import { usePatientProfile } from '../hooks';

import doorOpenIcon from '../../../../assets/img/button-icons/DoorOpen.svg';
import prioritisationIcon from '../../../../assets/img/button-icons/Prioritisation.svg';
import pillIcon from '../../../../assets/img/button-icons/Pill.svg';
import pencilIcon from '../../../../assets/img/pencil.png';
import CaremapprTooltip from '../../Tooltip/CaremapprTooltip';

interface ActionButtonsProps {
  setEditProfile: (value: boolean) => void;
  showEditButton: boolean;
  toggleMedicationProfile: () => void;
  onOpenAdditionalInsights: () => void;
  onOpenReconciliationSummary: () => void;
  showReconciliationSummary: boolean;
  showReviewTriggerButton: boolean;
  showMedicationProfileButton: boolean;
  showMhrSyncingButton: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = (props) => {
  const {
    setEditProfile,
    toggleMedicationProfile,
    onOpenAdditionalInsights,
    onOpenReconciliationSummary,
    showReconciliationSummary,
    showReviewTriggerButton,
    showMedicationProfileButton,
    showMhrSyncingButton,
    showEditButton,
  } = props;

  const { editProfile } = usePatientProfile();
  return (
    <Stack direction="vertical" gap={3}>
      <div className="profile-button-container">
        {showReconciliationSummary && (
          <CaremapprTooltip content="Reconciliation summary" place="bottom">
            <ButtonItem
              onClick={onOpenReconciliationSummary}
              imgSrc={doorOpenIcon}
              altText="Reconciliation summary button"
            />
          </CaremapprTooltip>
        )}
        {showReviewTriggerButton && (
          <CaremapprTooltip content="Insights & Feedback" place="bottom">
            <div className="profile-button-item">
              <button
                className="dotGreyBig"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onOpenAdditionalInsights();
                }}
              >
                <img
                  src={prioritisationIcon}
                  alt="Additional insights button"
                />
              </button>
            </div>
          </CaremapprTooltip>
        )}
        {showMedicationProfileButton && (
          <CaremapprTooltip content="Medication Profile" place="bottom">
            <ButtonItem
              onClick={toggleMedicationProfile}
              imgSrc={pillIcon}
              altText="Medication Profile button"
            />
          </CaremapprTooltip>
        )}
      </div>
      {!editProfile && showEditButton && (
        <div className="ms-auto">
          <div
            className="dotGreyBig clickable"
            onClick={() => setEditProfile(!editProfile)}
          >
            <img
              src={pencilIcon}
              alt="pencil"
              style={{ margin: '11px 0px 0px 11px' }}
            />
          </div>
        </div>
      )}
      {showMhrSyncingButton && <MHRSync />}
    </Stack>
  );
};

interface ButtonItemProps {
  onClick: () => void;
  imgSrc: string;
  altText: string;
}

const ButtonItem: React.FC<ButtonItemProps> = ({
  onClick,
  imgSrc,
  altText,
}) => (
  <div className="profile-button-item">
    <button type="button" className="dotGreyBig" onClick={onClick}>
      <img src={imgSrc} alt={altText} />
    </button>
  </div>
);

export default ActionButtons;
